"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _redux = require("redux");

var _env = require("./env");

var compose = _redux.compose;

var _default = function _default(rootReducer, initialState, middleware, storeName) {
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && (0, _env.debug)()) {
    compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: "MarketplaceUI" + (storeName ? "-" + storeName : '')
    });
  }

  var createStoreWithMiddleware = compose(_redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2.default)(middleware)))(_redux.createStore);
  return createStoreWithMiddleware(rootReducer, initialState);
};

exports.default = _default;
module.exports = exports.default;